module.exports = __webpack_public_path__ + "static/media/not_infant_friendly.d8e68be1.svg";